

export class CostReviewSmokeDampers {
  receivedBindingQuote!: number;
  smokeDamperQuoteAmount!: number;
  numberOfDampers!: number;
  manufacturer!: string;
  actuatorsFurnishedBy!: number;
  actuatorsWiredBy!: number;
  smokeDamperEndSwitchMonitoring!: number | null;
  ifYesWiring!: number | null;
  isSmokeDampersApplicable!: boolean;
}
